import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { textDecoration, bgChangeSection } from './_constants'

gsap.registerPlugin(ScrollTrigger)

const { defaultTextColor } = textDecoration.dataset
const { defaultBgColor } = bgChangeSection.dataset

export default function initBackgroundDecorationAnimation(el) {
  const { bgColor, textColor } = el.dataset

  ScrollTrigger.create({
    trigger: el,
    start: 'top 50%',
    end: 'bottom 50%',
    onToggle: ({ isActive }) => {
      gsap.set(textDecoration, {
        opacity: isActive ? 0.1 : 0,
        color: textColor || defaultTextColor,
      })

      gsap.set(bgChangeSection, {
        backgroundColor: bgColor || defaultBgColor,
      })
    },
  })
}
